module.exports = __webpack_public_path__ + "media/images/icons/flags/SE-abdc7a75a4005bb84a482de61010b570.svg";